module.exports = __webpack_public_path__ + "img/placeholder.602a8ab1.jpg";